import additionalTestList from './components/additionalTestList.vue';
import additionalTest from './components/additionalTest.vue';

export default {
  routes: [
    {
      path: '/',
      component:additionalTestList,
      name:'additionalTestList'
    },
    {
      path: '/:id',
      component:additionalTest,
      name:'additionalTest'
    },
  ]
};
